<template>
<div>
    <v-card flat color="white" v-if="ticket">
        <v-toolbar flat color='primary'>
            <v-toolbar-title style="color: white">
                Create Ticket
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn color="white" flat @click="$emit('close')">X</v-btn>
        </v-toolbar>
        <v-card-text>
            <v-layout justify-center align-center wrap>
                <v-flex xs5 mx-1>
                    <!-- <v-list>
                         <v-list-tile>
                            <v-list-tile-content>
                                <v-list-tile-title>
                                     Title:
                                </v-list-tile-title>
                            </v-list-tile-content>
                            <v-list-tile-action style="width: 200px">
                                
                            </v-list-tile-action>
                         </v-list-tile>

                    </v-list> -->
                    <v-text-field v-model="ticket.name" label="Title"></v-text-field>
                    <v-textarea height="425" auto-grow box label="Description" v-model="ticket.description"></v-textarea>

                </v-flex>
                <v-flex xs5 mx-1>
                    <v-list>

                        <v-list-tile>
                            <v-list-tile-action>
                                <v-icon>category</v-icon>
                            </v-list-tile-action>
                            <v-list-tile-content>
                                <v-list-tile-title>
                                    Category:
                                </v-list-tile-title>
                                <v-list-tile-sub-title>
                                    <i>Required</i>
                                </v-list-tile-sub-title>
                            </v-list-tile-content>
                            <v-list-tile-action style="width: 200px">
                                <v-select ref="ticketCategoryId" v-on:blur="$refs['ticketCategoryId'].blur()" :items="ticketCategories" item-text="name" v-model="ticket.ticketCategory" return-object></v-select>
                            </v-list-tile-action>
                        </v-list-tile>
                        <v-list-tile>
                            <v-list-tile-action>
                                <v-icon>view_list</v-icon>
                            </v-list-tile-action>
                            <v-list-tile-content>
                                <v-list-tile-title>
                                    Subcategory:
                                </v-list-tile-title>
                                  <v-list-tile-sub-title>
                                    <i>Required</i>
                                </v-list-tile-sub-title>
                            </v-list-tile-content>
                            <v-list-tile-action style="width: 200px">
                                <v-autocomplete ref="ticketCategoryItemId" v-on:blur="$refs['ticketCategoryItemId'].blur()" v-if="ticket.ticketCategory" :items="ticket.ticketCategory.ticketCategoryItems" item-text="name" item-value="id" label="Subcategory" v-model="ticket.ticketCategoryItemId"></v-autocomplete>
                            </v-list-tile-action>
                        </v-list-tile>
                        <v-list-tile>
                            <v-list-tile-action>
                                <v-icon>event</v-icon>
                            </v-list-tile-action>
                            <v-list-tile-content>
                                <v-list-tile-title>
                                    Date:
                                </v-list-tile-title>
                            </v-list-tile-content>
                            <v-list-tile-action style="width: 200px">
                                <span @click="dateModal=true" style="cursor: pointer">{{formatDate(ticket.dueDate)}}</span>
                            </v-list-tile-action>
                        </v-list-tile>
                        <v-list-tile>
                            <v-list-tile-action>
                                <v-icon>schedule</v-icon>
                            </v-list-tile-action>
                            <v-list-tile-content>
                                <v-list-tile-title>
                                    Time:
                                </v-list-tile-title>
                            </v-list-tile-content>
                            <v-list-tile-action style="width: 200px">
                                <VueCtkDateTimePicker format="HH:mm" formatted="HH:mm" minuteInterval="5" label="Due Time" only-time v-model="ticket.dueTime" />
                            </v-list-tile-action>
                        </v-list-tile>

                        <v-list-tile>
                            <v-list-tile-content>
                                <v-list-tile-title>
                                    Status:
                                </v-list-tile-title>
                            </v-list-tile-content>
                            <v-list-tile-action style="width: 200px">
                                <v-autocomplete ref="status" v-on:blur="$refs['status'].blur()" :items="statuses" v-model="ticket.currentStatus"></v-autocomplete>

                            </v-list-tile-action>
                        </v-list-tile>

                        <v-list-tile>
                            <v-list-tile-content>
                                <v-list-tile-title>
                                    Priority:
                                </v-list-tile-title>
                            </v-list-tile-content>
                            <v-list-tile-action style="width: 200px">
                                <v-autocomplete ref="priority" v-on:blur="$refs['priority'].blur()" :items="importanceOptions" v-model="ticket.importance"></v-autocomplete>

                            </v-list-tile-action>
                        </v-list-tile>
                        <v-list-tile>
                            <v-list-tile-action>
                                <v-icon>business</v-icon>
                            </v-list-tile-action>
                            <v-list-tile-content>
                                <v-list-tile-title>
                                    Shared With:
                                </v-list-tile-title>
                            </v-list-tile-content>
                            <v-list-tile-action style="width: 200px">
                                <v-autocomplete ref="customerOrganisations" v-on:blur="$refs['customerOrganisations'].blur()" :items="customerOrganisations" item-text="connectedOrganisation.name" item-value="connectedOrganisation.id" v-model="ticket.customerOrganisationId"></v-autocomplete>

                            </v-list-tile-action>
                        </v-list-tile>

                        <v-list-tile>
                            <v-list-tile-action>
                                <v-icon>groups</v-icon>
                            </v-list-tile-action>
                            <v-list-tile-content>
                                <v-list-tile-title>
                                    User Role:
                                </v-list-tile-title>
                                <v-list-tile-sub-title>
                                    <i>Required</i>
                                </v-list-tile-sub-title>
                            </v-list-tile-content>
                            <v-list-tile-action style="width: 200px">
                                <v-autocomplete style="margin: 0; padding: 0" dense class="my-0 py-0" ref="userRoleId" v-on:blur="$refs['userRoleId'].blur()" :items="userRoles" item-text="name" item-value="id" v-model="ticket.userRoleId" label="User Role*"></v-autocomplete>
                            </v-list-tile-action>
                        </v-list-tile>

                        <v-list-tile>
                            <v-list-tile-action>
                                <v-icon>person</v-icon>
                            </v-list-tile-action>
                            <v-list-tile-content>
                                <v-list-tile-title>
                                    Assigned User:
                                </v-list-tile-title>
                            </v-list-tile-content>
                            <v-list-tile-action style="width: 200px">
                                <v-autocomplete style="marginp: 0; padding: 0" dense ref="assignedToId" v-on:blur="$refs['assignedToId'].blur()" :items="filteredUsers" item-text="name" item-value="id" v-model="ticket.assignedToId" label="Assigned User"></v-autocomplete>

                            </v-list-tile-action>
                        </v-list-tile>

                        <v-list-tile>
                            <v-list-tile-action>
                                <v-icon>location_on</v-icon>
                            </v-list-tile-action>
                            <v-list-tile-content>
                                <v-list-tile-title>
                                    <span v-if="ticket.locationNode||ticket.locationNetwork||ticket.location">
                                        <span v-if="ticket.location">
                                            {{ticket.location.locationDescription}}
                                        </span>
                                        <span v-else-if="ticket.locationNetwork">
                                            {{ticket.locationNetwork.name}}
                                        </span>
                                        <span v-if="ticket.locationNode">
                                            {{ticket.locationNode.name}}
                                        </span>
                                    </span>
                                    <span v-else>No attached location</span>
                                </v-list-tile-title>
                                <v-list-tile-sub-title v-if="ticket.locationNode||ticket.locationNetwork||ticket.location">
                                    Location
                                </v-list-tile-sub-title>
                            </v-list-tile-content>
                            <v-list-tile-action style="width: 200px">
                                <v-icon @click="locationSearch=true">search</v-icon>
                            </v-list-tile-action>
                        </v-list-tile>

                        <v-list-tile>
                            <v-list-tile-action>
                                <v-icon>description</v-icon>
                            </v-list-tile-action>
                            <v-list-tile-content>
                                <v-list-tile-title style="align-text: center;cursor: pointer" v-if="tick&&ticket.documents.length>0" @click="documentsModal=true">
                                    <v-chip style="height: 20px">{{ticket.documents.length}}</v-chip> Document(s)
                                </v-list-tile-title>
                                <v-list-tile-title v-else>
                                    No documents
                                </v-list-tile-title>
                            </v-list-tile-content>
                            <v-list-tile-action>

                                <div :class="['dropZone', dragging ? 'dropZone-over' : '']" @dragenter="dragging = true" @dragleave="dragging = false">
                                    <div class="dropZone-info" @drag="onChange">
                                        <!-- <v-btn icon><v-icon>add</v-icon></v-btn> -->
                                        <span class="dropZone-title" style="font-size: 12px; cursor: pointer">Drop file or click to upload</span>
                                    </div>
                                    <input type="file" @change="onChange">
                                </div>

                            </v-list-tile-action>
                        </v-list-tile>

                    </v-list>
                </v-flex>

                <!-- <v-flex xs5 mx-1>
                    <v-select box append-icon="search" label="Search Type" :items="searchTypes" v-model="selectedSearchType"></v-select>
                </v-flex> -->
                <!-- <v-flex xs10 mx-1>
                    <h3>Location Details: </h3>
                    <v-layout justify-center>
                        <v-flex xs4>
                            <v-autocomplete class="px-2" solo dense ref="locationNodeId" clearable v-on:blur="$refs['locationNodeId'].blur()" :items="locationNodes" item-text="name" item-value="id" v-model="ticket.locationNodeId" label="Location Node"></v-autocomplete>

                        </v-flex>
                        <v-flex xs4>
                            <v-autocomplete solo class="px-2" dense ref="locationNetworkId" clearable v-on:blur="$refs['locationNetworkId'].blur()" :items="filteredNetworks" item-text="name" item-value="id" v-model="ticket.locationNetworkId"  @change="fetchLocations()" label="Network"></v-autocomplete>

                        </v-flex>
                        <v-flex xs4>
                            <v-progress-circular color="primary" v-if="loadingLocations" indeterminate></v-progress-circular>
                            <v-autocomplete v-else solo class="px-2" dense ref="locationId" v-on:blur="$refs['locationId'].blur()" clearable :items="locations" item-text="locationDescription" item-value="id" v-model="ticket.locationId" label="Location"></v-autocomplete>

                        </v-flex>

                    </v-layout>

                </v-flex> -->
                <v-flex xs12 class="text-xs-center">
                    <v-btn @click="createTicket()" color="primary" round class="white--text" :disabled="!ticket.ticketCategory||!ticket.userRoleId||!ticket.ticketCategoryItemId">Submit</v-btn>
                </v-flex>
            </v-layout>
        </v-card-text>
    </v-card>

    <v-dialog v-model="documentsModal" persistent width="750px">
        <v-card>
            <v-toolbar flat color="white">
                <v-toolbar-title>
                    Documents
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn flat @click="documentsModal=false">X</v-btn>
            </v-toolbar>
            <v-card-text>
                <v-layout justify-center align-center wrap>
                    <v-flex xs12 v-for="document in ticket.documents" :key="document.name">
                        <v-card flat color="white" style="border-top: 1px solid lightgrey">
                            <v-layout justify-left align-center wrap>
                                <v-flex xs3>
                                    <!-- <h4 class="grey--text font-weight-light">{{formatDate(new Date(document.createdAt))}}</h4> -->
                                </v-flex>
                                <v-flex xs7>
                                    <h4 class="grey--text">{{document.name}}</h4>
                                </v-flex>
                                <v-flex xs2>
                                    <v-layout justify-center>
                                        <!-- <v-icon @click="viewFile(document)">open_in_new</v-icon> -->
                                        <v-icon @click="downloadFile(document)">download</v-icon>
                                        <v-icon color="red" @click="deleteFile(document)">delete</v-icon>
                                    </v-layout>
                                </v-flex>
                            </v-layout>
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-card-text>
        </v-card>
    </v-dialog>

    <v-dialog v-model="locationSearch" width="400px">
        <v-card>
            <v-toolbar flat color="white">
                <v-toolbar-title>
                    Location Search
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn flat @click="locationSearch = false">X</v-btn>
            </v-toolbar>
            <v-card-text>
                <v-layout justify-center wrap>
                    <v-flex xs10>
                        <v-autocomplete class="px-2" box dense ref="locationNodeId" return-object clearable v-on:blur="$refs['locationNodeId'].blur()" :items="locationNodes" item-text="name" item-value="id" v-model="ticket.locationNode" label="Location Node"></v-autocomplete>

                    </v-flex>
                    <v-flex xs10>
                        <v-autocomplete box :disabled="!ticket.locationNode" return-object class="px-2" dense ref="locationNetworkId" clearable v-on:blur="$refs['locationNetworkId'].blur()" :items="filteredNetworks" item-text="name" item-value="id" v-model="ticket.locationNetwork" @change="fetchLocations()" label="Network"></v-autocomplete>

                    </v-flex>
                    <v-flex xs10>
                        <v-progress-circular color="primary" v-if="loadingLocations" indeterminate></v-progress-circular>
                        <v-autocomplete v-else box :disabled="!ticket.locationNetwork" return-object class="px-2" dense ref="locationId" v-on:blur="$refs['locationId'].blur()" clearable :items="locations" item-text="locationDescription" item-value="id" v-model="ticket.location" label="Location"></v-autocomplete>

                    </v-flex>
                    <v-flex xs12 class="text-xs-center">
                        <v-btn flat color="primary" @click="locationSearch = false">Done</v-btn>
                    </v-flex>

                </v-layout>
            </v-card-text>
        </v-card>

    </v-dialog>

    <v-dialog ref="dialog" v-model="dateModal" lazy full-width width="750px">
        <v-date-picker style="height: 350px" landscape full-width scrollable v-model="pickerDate">
            <v-spacer></v-spacer>
            <v-btn flat color="primary" @click="dateModal=false">OK</v-btn>
        </v-date-picker>

    </v-dialog>

</div>
</template>

<script>
import Api from "@/services/Api.js";
import dateformat from 'dateformat'
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
export default {
    props: ['ticket'],
    components: {
        VueCtkDateTimePicker
    },
    data() {
        return {
            customerOrganisations: [],
            dateModal: false,
            documentsModal: false,
            dragging: false,
            file: '',
            filteredUsers: [],
            organisationUsers: [],
            locationNodes: [],
            locationNetworks: [],
            locations: [],
            loadingLocations: false,
            locationSearch: false,
            pickerDate: new Date().toISOString().substr(0, 10),
            // ticket: {
            //     currentStatus: 'Pending',
            //     importance: 'Average',
            //     dueDate: new Date()
            // },
            ticketCategories: [],
            searchTypes: ['Node', 'Network', 'Location'],
            selectedSearchType: 'Location',
            userRoles: [],
            statuses: ["Incomplete", "Pending", "In Progress", "Complete", "Canceled"],
            importanceOptions: ["Normal", "Not Critical", "Average", "Urgent"],
        }
    },
    watch: {
        // 'ticket.dueDate': {
        //     handler(){
        //         this.pickerDate = new Date(this.ticket.dueDate).toISOString().substr(0, 10)
        //     }
        // },
        pickerDate(value) {
            if (value) {
                this.ticket.dueDate = new Date(value)
            }
        },
        "ticket.locationNode": {
            immediate: true,
            async handler(value) {
                this.ticket.locationNetworkId = null

            }
        },
        // "ticket.locationNetworkId": {
        //     immediate: true,
        //     async handler(value) {
        //         console.log(value)
        //         this.ticket.locationId = null
        //         if (value) {
        //             this.fetchLocations(value)
        //         }
        //     }
        // },
        "ticket.userRoleId": {
            immediate: true,
            async handler(value) {
                if (value && value !== null) {
                    this.ticket.assignedToId = null

                    Api()
                        .get("/userRoleContact/byUserRole/" + value)
                        .then((response) => {
                            this.filteredUsers = response.data.map((x) => x.contact);
                        });
                }
            },
        },
    },
    computed: {
        filteredNetworks() {
            let result = this.locationNetworks
            if (this.ticket.locationNode) {
                result = result.filter(x => x.locationNodeId == this.ticket.locationNode.id)
            }
            return result
        },

    },
    created() {
        this.fetchTicketCategories()
        this.fetchOrgContacts()
        this.fetchUserRoles()
        this.fetchLocationNodes()
        this.fetchLocationNetworks()
        this.fetchConnectedOrganisations()
    },
    methods: {
        onChange(e) {
            var files = e.target.files || e.dataTransfer.files;
            if (!files.length) {
                this.dragging = false;
                return;
            }
            this.createFile(files[0]);
        },
        async createFile(file) {
            // if (!file.type.match('text.*')) {
            //     alert('please select txt file');
            //     this.dragging = false;
            //     return;
            // }

            if (file.size > 5000000) {
                alert('please check file size no over 5 MB.')
                this.dragging = false;
                return;
            }

            this.file = file;
            var reader = new FileReader();
            await reader.readAsBinaryString(this.file);
            reader.onload = () => {
                file = btoa(reader.result)
                this.file.base64 = file;
                console.log(this.file)
                this.ticket.documents.push(this.file)
            }

            this.dragging = false;
        },
        deleteFile(item) {
            this.ticket.documents.splice(this.ticket.documents.indexOf(item), 1)
        },
        createTicket() {
            if (this.ticket.location) {
                this.ticket.locationId = this.ticket.location.id

            } else if (this.ticket.locationNetwork) {
                this.ticket.locationNetworkId = this.ticket.locationNetwork.id

            } else if (this.ticket.locationNode) {
                this.ticket.locationNodeId = this.ticket.locationNode.id
            }
            if(this.ticket.ticketCategory){
                this.ticket.ticketCategoryId = this.ticket.ticketCategory.id
            }
            Api().post('/ticket', this.ticket).then(async res => {
                // this.$router.push({
                //     path: "/serviceAccounts/" + this.ticket.serviceAccountId
                // });
                for (let i = 0; i < this.ticket.documents.length; i++) {
                    this.ticket.documents[i].ticketId = res.data.id
                    await Api().post('/upload', this.ticket.documents[i])
                }
                this.ticket = {
                    currentStatus: 'Pending',
                    importance: 'Average'
                }
                this.$emit('ticketCreated')
            })
        },
        downloadFile(item) {
            const linkSource = `data:${item.type};base64,${item.base64}`;
            const downloadLink = document.createElement("a");
            const fileName = item.name;
            downloadLink.href = linkSource;
            downloadLink.download = fileName;
            downloadLink.click();
        },
        fetchConnectedOrganisations() {
            Api().get('/organisationConnection').then(res => {
                this.customerOrganisations = res.data
            })
        },
        fetchLocationNodes() {
            Api().get('/locationNodes/active').then(res => {
                this.locationNodes = res.data
            })
        },
        fetchLocationNetworks() {
            Api().get('/locationNetworks/basicActive').then(res => {
                this.locationNetworks = res.data
            })
        },
        fetchLocations() {
            if (this.ticket.locationNetwork) {
                this.ticket.locationNetworkId = this.ticket.locationNetwork.id
                this.loadingLocations = true
                this.locations = []
                Api().get('/locations/active/basic/' + this.ticket.locationNetworkId).then(res => {
                    this.locations = res.data
                    this.loadingLocations = false
                })
            }

        },
        // fetchLocationNodes(){
        //     Api().get('/locationNodes/basic').then(res=>{
        //         this.locationNodes = res.data
        //     })
        // },
        fetchTicketCategories() {
            Api()
                .get('/ticketCategory')
                .then(response => {
                    this.ticketCategories = response.data
                })
        },
        fetchOrgContacts() {
            this.organisationUsers = [];
            Api()
                .get("/organisationContact")
                .then(async (response) => {
                    let contactArray = await response.data.map((x) => x.contact);
                    this.organisationUsers = contactArray.map(x => ({
                        id: x.id,
                        fullname: x.name + ' ' + x.surname,
                        name: x.name,
                        surname: x.surname,
                        email: x.email,
                        mobileNumber: x.mobileNumber
                    }))
                });
        },
        fetchUserRoles() {
            Api()
                .get("/userRole")
                .then((response) => {
                    this.userRoles = response.data;
                });
        },
        formatDateTime(date) {
            if (date !== null) {
                return dateformat(date, "yyyy-mm-dd HH:MM");
            } else {
                null;
            }
        },
        formatDate(date) {
            if (date !== null) {
                return dateformat(date, "yyyy-mm-dd");
            } else {
                null;
            }
        },
        updateTicket() {
            Api().put('/ticket/' + this.ticket.id, this.ticket).then(res => {

            })
        },
        refreshTicket() {
            Api().get('/ticket/' + this.ticket.id).then(res => {
                this.$emit('updated', res.data)
            })
        },
        subscribeToTicket() {
            Api().post('/ticketSubscriber', {
                ticketId: this.ticket.id,
                contactId: this.$store.state.user.id
            }).then(res => {
                this.refreshTicket()
            })
        },
    }
}
</script>

<style scoped>
.dropZone {
    width: 180px;
    height: 90%;
    position: relative;
    border: 2px dashed #eee;
}

.dropZone:hover {
    border: 2px solid #2e94c4;
}

.dropZone:hover .dropZone-title {
    color: #1975A0;
}

.dropZone-info {
    color: #A8A8A8;
    position: absolute;
    top: 50%;
    width: 100%;
    transform: translate(0, -50%);
    text-align: center;
}

.dropZone-title {
    color: #787878;
}

.dropZone input {
    position: absolute;
    cursor: pointer;
    top: 0px;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
}

.dropZone-upload-limit-info {
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
}

.dropZone-over {
    background: #5C5C5C;
    opacity: 0.8;
}

.dropZone-uploaded {
    width: 80%;
    height: 200px;
    position: relative;
    border: 2px dashed #eee;
}

.dropZone-uploaded-info {
    display: flex;
    flex-direction: column;
    align-items: center;
    color: #A8A8A8;
    position: absolute;
    top: 50%;
    width: 100%;
    transform: translate(0, -50%);
    text-align: center;
}
</style>
